import { createApp } from 'vue'
import 'normalize.css/normalize.css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/link/style/css'
import App from './App.vue'
import * as Sentry from '@sentry/vue'
// import WebStabilityObserver from 'web-stability-observer'
import registerGlobalComp from '@/components/registerGlobalComp'
import setupGlobDirectives from '@/directives'
import { setupRouter, router } from '@/router'
import { setupStore } from '@/stores'
import { setupGlobVxeTable } from '@/plugins'
import './permission'
import '@/assets/styles/tailwind.css'
import '@/assets/styles/index.scss'
import 'vxe-table/lib/style.css'
import VueClickAway from 'vue3-click-away' // 点击其他地方关闭模块
import { printANSI } from '@/utils/screenLog'
import { getEnvMode } from './utils/env'

function bootstrap() {
  // 打印构建信息
  printANSI()
  // 测试和线上环境打开
  const environment = getEnvMode()
  // const isInitSentry = ['prod', 'production'].includes(environment)
  const isInitSentry = false
  const app = createApp(App)
  // Vxe 插件
  setupGlobVxeTable(app)
  // 注册全局指令
  app.use(setupGlobDirectives)
  // 注册全局组件
  app.use(registerGlobalComp)
  // 注册store
  setupStore(app)
  // 注册路由
  setupRouter(app)
  // new WebStabilityObserver()

  // 防DNS劫持
  // try {
  //   const iframe = document.createElement('iframe')
  //   iframe.style.display = 'none'
  //   document.body.appendChild(iframe)

  //   const nativePromiseThen = iframe?.contentWindow?.Promise?.prototype?.then

  //   if (nativePromiseThen && Promise.prototype.then !== nativePromiseThen) {
  //     // 只有当前 Promise.then 被修改过才重置
  //     Object.defineProperty(Promise.prototype, 'then', {
  //       value: nativePromiseThen,
  //       writable: true,
  //       configurable: true,
  //       enumerable: false
  //     })
  //   }

  //   document.body.removeChild(iframe)
  // } catch (error) {
  //   console.warn('Promise reset failed:', error)
  // }

  // 注册全局指令
  app.use(VueClickAway)
  // sentry忽略的错误msg 白名单
  const sentryErrorWhiteList = [
    'Unable to preload CSS',
    'Failed to fetch dynamically imported',
    'Importing a module script failed',
    'y.getBoundingClientRect is not a function',
    "'text/html' is not a valid JavaScript MIME type",
    "Cannot destructure property 'container' of",
    "Cannot read properties of null (reading 'emitsOptions')",
    '请求出错,请稍后再试',
    '已取消'
  ]
  isInitSentry &&
    Sentry.init({
      app,
      environment,
      dsn: 'https://382b6b2f5c5d41f99902da986329353f@sentry.jyunkj.cn/8',
      integrations: [
        Sentry.browserTracingIntegration({ router })
        // Sentry.replayIntegration()
      ],
      release: environment,
      sampleRate: 0.25, // 25% 的错误进行抽样
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.5, // 统一采样率 大约 50% 的 transaction 将被记录和发送

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: ['localhost', /^http:\/\//],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 0.5,
      ignoreErrors: [
        /ResizeObserver loop limit exceeded/,
        'Network Error',
        'URIError',
        'INVALID_STATE_ERROR',
        'Large Render Blocking Asset',
        ...sentryErrorWhiteList
      ],
      denyUrls: [
        // Chrome extensionsn
        /extensions\//i,
        /^chrome:\/\//i
      ],

      beforeSend(event, hint) {
        // 获取原始异常对象
        const originalException = hint.originalException as any
        // 检查事件是否来自node_modules目录
        if (event.exception && event.exception.values) {
          for (const value of event.exception.values) {
            if (value.stacktrace && value.stacktrace.frames) {
              for (const frame of value.stacktrace.frames) {
                if (frame.filename && frame.filename.includes('node_modules')) {
                  return null // 忽略这个事件
                }
              }
            }
          }
        }
        // UnhandledRejection
        if (Object.prototype.toString.call(originalException) !== '[object Error]') {
          return null
        }
        // 检查错误消息，如果包含 "xxx" 则返回 null 来阻止上报
        if (
          originalException &&
          sentryErrorWhiteList.some(item => originalException?.message?.includes(item))
        ) {
          return null
        }
        // 如果错误不是要忽略的类型，则允许上报
        return event
      }
    })

  app.mount('#app')
}
bootstrap()
